export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  ENDPOINTS: {
    AUTH: '/api/auth',
    EQUIPMENT: '/api/equipment',
    MONITORING: '/api/monitoring',
    ANALYTICS: '/api/analytics',
    ALERTS: '/api/alerts',
    REPORTS: '/api/reports',
  },
  WEBSOCKET_URL: import.meta.env.VITE_WS_URL || 'ws://localhost:8000/ws',
  TIMEOUT: 30000,
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000,
} as const

export const REFRESH_INTERVALS = {
  DASHBOARD: 30000, // 30 seconds
  REAL_TIME: 5000,  // 5 seconds
  CHARTS: 60000,    // 1 minute
  ALERTS: 15000,    // 15 seconds
} as const